import { LoadableElement } from '@99designs/common/components/LoadableElement';
import {
    getSquarespaceApiBrief as getSquarespaceApiBriefQuery,
    getSquarespaceApiBriefVariables,
} from '__generated__/getSquarespaceApiBrief';
import { DesignerSource } from '__generated__/types';
import { handleGraphQLError } from 'common/utils/Apollo';
import { errorNotFound } from 'projects/components/ErrorBoundary';
import * as React from 'react';
import { Query } from 'react-apollo';
import { RouteComponentProps } from 'react-router-dom';
import DirectWorkflow from './DirectWorkflow';
import RecommendationWorkflow from './RecommendationWorkflow';
import queries from './SquarespaceApiBrief.graphql';

type RouteProps = RouteComponentProps<{ briefId: string }>;

const WrappedBrief: React.SFC<RouteProps> = props => (
    <Query<getSquarespaceApiBriefQuery, getSquarespaceApiBriefVariables>
        query={queries.getSquarespaceApiBrief}
        variables={{ id: props.match.params.briefId }}
    >
        {({ data, error, loading }) => {
            if (loading) {
                return <LoadableElement isLoading={true} variations={['relative ']} />;
            }

            if (error) {
                handleGraphQLError(error);
            }

            // We can remove this block if we update the schema to return
            // an error if a structuredBrief with the briefID is not found
            if (data && !data.structuredBrief) {
                throw errorNotFound;
            }

            if (data && data.structuredBrief) {
                const directDesigners = data.structuredBrief.designersWithSource.filter(
                    designer => designer.source === DesignerSource.API
                );

                if (directDesigners.length) {
                    return <DirectWorkflow brief={data.structuredBrief!} />;
                } else {
                    return <RecommendationWorkflow brief={data.structuredBrief!} />;
                }
            }

            return null;
        }}
    </Query>
);

export default WrappedBrief;
